module.exports = __webpack_public_path__ + "static/media/2011.c8578ec3.svg";